<template>
    <div>
        <input
            :value="phone"
            :required="required"
            :class="inputClass"
            :name="name"
            @input="onInput"
        >
        <small>{{ $t('components.phone_input.format_hint') }}</small>
    </div>
</template>

<script>
    export default {
        props: {
            name: {
                type: String,
                default: '',
            },

            value: {
                type: String,
                default: '',
            },

            required: {
                type: Boolean,
                default: false,
            },

            inputClass: {
                type: String,
                default: '',
            },
        },

        data() {
            return {
                phone: this.value,
            };
        },

        watch: {
            value: function (value) {
                this.phone = value;
            },
        },

        methods: {
            onInput(event) {
                const phoneRegex = /^\+{0,1}[\d\s]{0,20}$/;

                if (!event.target.value.match(phoneRegex)) {
                    event.target.value = this.phone;
                    return;
                }

                this.phone = event.target.value;
                this.$emit('input', event.target.value);
            },
        },
    };
</script>
